module.exports = __webpack_public_path__ + "static/img/Fitlers.d58ba7fc.svg";